// src/data.js
import { FireIcon, BoltIcon } from '@heroicons/react/24/outline';

export const siteInfo = {
  companyName: "Drive Dobias LLC",
  tagline: "Premium vehicles, flexible rentals, and a seamless booking experience.",
};

export const fleet = [
  {
    name: "2019 Chevrolet Bolt EV",
    trim: "Premier",
    seats: 5,
    fuel: "Electric",
    desc: "Compact and efficient, perfect for city driving.",
    // price: 50,
    turoUrl:
      "https://turo.com/us/en/car-rental/united-states/muskego-wi/chevrolet/bolt-ev/3242259",
    fuelIcon: <BoltIcon className="w-6 h-6 mr-1" />,
    img: "/images/bolt.jpg",
    gallery: ["/images/bolt.jpg"],
    specs: {
      drivetrain: "Front-wheel drive (FWD)",
      range: "238 miles (EPA est.)",
      horsepower: "200 hp (150 kW)",
      battery: "60 kWh lithium-ion",
      charging:
        "Level 1: ~4–5 days • Level 2: ~10 hours • DC Fast: ~1 hour (0–80%)",
      trimDiff:
        "Premier trim adds heated steering wheel, leather-appointed seats, surround vision camera, rear cross-traffic alert, lane change alert, and upgraded infotainment over the LT.",
    },
  },
  {
    name: "2019 Tesla Model 3",
    trim: "Standard Range Plus",
    seats: 5,
    fuel: "Electric",
    desc: "Power and space for family trips or group adventures.",
    // price: 60,
    turoUrl:
      "https://turo.com/us/en/car-rental/united-states/muskego-wi/tesla/model-3/3386373",
    fuelIcon: <BoltIcon className="w-6 h-6 mr-1" />,
    img: "/images/model3.jpg",
    gallery: ["/images/model3.jpg"],
    specs: {
      drivetrain: "Rear-wheel drive (RWD)",
      range: "240 miles (EPA est.)",
      horsepower: "283 hp",
      battery: "50 kWh lithium-ion",
      charging:
        "Level 2: ~10 hours • DC Fast (Supercharger): ~170 miles in 30 minutes",
      trimDiff:
        "Standard Range Plus includes partial premium interior, 12-way power front seats, upgraded audio, and Autopilot standard. Positioned between the base Standard Range and Long Range AWD.",
    },
  },
  {
    name: "2022 Toyota Sienna",
    trim: "Woodland Edition",
    seats: 7,
    fuel: "Hybrid",
    desc: "Versatile and spacious, perfect for families.",
    // price: 79,
    turoUrl:
      "https://turo.com/us/en/minivan-rental/united-states/muskego-wi/toyota/sienna/3333700",
    fuelIcon: <FireIcon className="w-6 h-6 mr-1" />,
    img: "/images/sienna.jpg",
    gallery: ["/images/sienna.jpg"],
    specs: {
      drivetrain: "All-wheel drive (AWD standard on Woodland)",
      range: "~600 miles combined (36 mpg city/highway, 18-gal tank)",
      horsepower: "245 hp (2.5L I4 hybrid system)",
      battery: "Hybrid nickel-metal hydride (self-charging, not plug-in)",
      charging: "Not plug-in; charges via regenerative braking",
      trimDiff:
        "Woodland Edition adds standard AWD, increased ground clearance, roof rails with crossbars, 1500W power outlet, and rugged styling cues compared to other trims.",
    },
  },
  {
    name: "2021 Tesla Model Y",
    trim: "Long Range",
    seats: 5,
    fuel: "Electric",
    desc: "Spacious and powerful, combining performance with everyday practicality.",
    // price: 85,
    turoUrl: "https://turo.com/us/en/suv-rental/united-states/muskego-wi/tesla/model-y/3723592",
    fuelIcon: <BoltIcon className="w-6 h-6 mr-1" />,
    img: "/images/modely.jpg",
    gallery: ["/images/modely.jpg"],
    specs: {
      drivetrain: "Dual Motor All-wheel drive (AWD)",
      range: "325 miles (EPA est.)",
      horsepower: "346 hp",
      battery: "75–81 kWh lithium-ion",
      charging:
        "Level 2: ~8–10 hours • DC Fast (Supercharger): ~175 miles in 30 minutes",
      trimDiff:
        "Long Range trim features dual motors for enhanced performance and all-weather capability, premium interior, advanced safety features, and standard Autopilot. Positioned between the base RWD and high-performance Plaid variants.",
    },
  },
];

export const hero = {
  headline: "Milwaukee’s Premier Electric & Hybrid Rentals",
  tagline: "Premium rentals that combine sustainability with style — serving MKE and beyond.",
  ctaText: "View Our Fleet",
  ctaLink: "#vehicles",
  backgroundImage: "/images/modelx.jpg", // optional — leave empty for solid color
};

export const howItWorks = [
  { icon: "search", title: "Browse", desc: "Find the perfect vehicle for your trip." },
  { icon: "calendar", title: "Book", desc: "Select your dates and confirm instantly." },
  { icon: "key", title: "Drive", desc: "Pick up and enjoy your ride." },
];

export const requirements = [
  "Valid driver’s license",
  "Minimum age: 25 years",
  "Proof of insurance",
  "Security deposit",
];

export const faqs = [
  {
    q: "What areas do you serve?",
    a: "We exclusively serve the Greater Milwaukee Area and surrounding suburbs.",
  },
  {
    q: "What is your cancellation policy?",
    a: "Cancellations made more than 48 hours before pickup are fully refundable.",
  },
  {
    q: "Do you offer delivery?",
    a: "Yes, we can deliver vehicles within a 20-mile radius for an additional fee.",
  },
];